import {h} from 'preact'
import {Link as WouterLink} from 'wouter'
import type {LinkProps as WouterLinkProps} from 'wouter'
import {sections} from '../pages'

export const Link: React.FC<LinkProps> = (props) => {
  const [, p1, page] = props.href.split('/')
  const load = sections[p1]?.[page || 'getting-started']?.load

  return (
    <WouterLink
      onTouchStart={load}
      onMouseEnter={load}
      onMouseDown={load}
      {...props}
    />
  )
}

export type LinkProps = WouterLinkProps & {}
